import PropTypes from 'prop-types';

export const exactUserProps = {
	id: PropTypes.number,
	email: PropTypes.string,
	name: PropTypes.string,
	firstName: PropTypes.string,
	lastName: PropTypes.string,
};

const userProps = PropTypes.oneOfType([
	PropTypes.bool,
	PropTypes.shape(exactUserProps)
]);

export default userProps;
